<script lang="ts">
    // Components
    import NowPlayingInfoPanel from './NowPlayingInfoPanel.svelte';
    import NowPlayingInfoSidebar from './NowPlayingInfoSidebar.svelte';

    // Types
    import type { QueueComponentType } from '~/components/structure/Players/components/NowPlayingQueue/types';

    // Stores
    import { getI18n } from '~/stores/i18n';
    import { queueMetadata } from '~/stores/queue-metadata';

    // Utilities
    import { getPlayback } from '~/utils/playback';
    import { getJet } from '~/jet';

    /**
     * Used to determine if this is the side drawer or now playing panel
     */
    export let componentType: QueueComponentType;

    /**
     * Used by panel rendering
     */
    export let isMobileView: boolean = false;

    /**
     * Used by sidebar rendering
     */
    export let isOpen: boolean = false;

    /**
     * Element to tell context menu where to render menu options
     * Only used by PlaybackItem in mobile view NowPlayingQueuePanel
     */
    export let parentElement: HTMLElement = null;

    const i18n = getI18n();
    const jet = getJet();
    const { queue } = getPlayback();

    // Labels
    const emptyInfoText = $i18n.t('ASE.Web.MusicClassical.Info.Empty');
    const infoHeading = $i18n.t('ASE.Web.MusicClassical.UpNext.Info');

    // Queue Items
    $: nowPlayingItemId = $queue.nowPlayingItemInfo?.id;
    $: nowPlayingItem = $queueMetadata.get(nowPlayingItemId);

    $: isEmpty = !nowPlayingItem;
    $: queueIsPlaying = $queue?.derivedStates?.isPlaying;
    $: queueIsPaused = $queue?.derivedStates?.isPaused;
</script>

{#if componentType === 'panel'}
    <NowPlayingInfoPanel
        {isMobileView}
        item={nowPlayingItem}
        {isEmpty}
        {emptyInfoText}
        bind:parentElement
    />
{:else}
    <NowPlayingInfoSidebar
        item={nowPlayingItem}
        {isOpen}
        {isEmpty}
        {emptyInfoText}
        {infoHeading}
        on:toggleOpen
    />
{/if}
